var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "user",
      attrs: { to: { name: "view-user", params: { user_id: _vm.rowData.id } } },
    },
    [
      _vm.rowData.avatar
        ? _c("img", {
            key: _vm.rowData.id,
            staticClass: "avatar avatar--small",
            attrs: {
              src: `/images/avatar/${_vm.rowData.id}`,
              title: _vm.rowData.name,
              alt: `${_vm.rowData.name}'s avatar`,
              width: "32",
              height: "32",
            },
          })
        : _c("img", {
            staticClass: "avatar avatar--small",
            attrs: { src: "//placehold.it/32x32", width: "32", height: "32" },
          }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.rowData.name))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }